import { VertragState } from './vertrag/state';
// import { UserState } from './user/state';

export const stateList = [VertragState];
